import React from "react";
import PropTypes from "prop-types";

export default function Highlight({ children }) {
  return <b>{children}</b>;
}

Highlight.propTypes = {
  children: PropTypes.node.isRequired,
};
